'use strict';

exports.array = require('./array');
exports.matrix = require('./matrix');



//////////////////
// WEBPACK FOOTER
// ./~/ml-savitzky-golay-generalized/~/ml-stat/index.js
// module id = 117
// module chunks = 0